import { useEffect } from "react";
import * as Sentry from "@sentry/react-router";
import { useUser } from "~/hooks/use-user";

export function useSentryUser() {
  const { user, authenticated } = useUser();

  useEffect(() => {
    if (authenticated && user) {
      Sentry.setUser({
        id: user.id,
        email: user.email || undefined,
        username: user.name || undefined,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user, authenticated]);
}
